import { useProfile } from './useProfile'

export const useLayoutState = () => {
  const {
    isCurrentUser,
    pelatihanMandiriBadgeCount,
    aksiNyataCount,
    buktiKaryaCount,
    ceritaPraktikCount,
    perangkatAjarCount,
  } = useProfile()

  const hasPelatihanMandiri =
    pelatihanMandiriBadgeCount > 0 && aksiNyataCount > 0
  const hasBuktiKarya = buktiKaryaCount > 0
  const hasCeritaPraktik = ceritaPraktikCount > 0
  const hasPerangkatAjar = perangkatAjarCount > 0

  const showPelatihanMandiriSection = isCurrentUser || hasPelatihanMandiri
  const showBuktiKaryaSection = isCurrentUser || hasBuktiKarya
  const showCeritaPraktikSection = isCurrentUser || hasCeritaPraktik
  const showPerangkatAjarSection = isCurrentUser || hasPerangkatAjar

  const isProfileKaryaEmpty =
    !showPelatihanMandiriSection &&
    !showBuktiKaryaSection &&
    !showCeritaPraktikSection &&
    !showPerangkatAjarSection

  return {
    hasPelatihanMandiri,
    hasBuktiKarya,
    hasCeritaPraktik,
    hasPerangkatAjar,

    showPelatihanMandiriSection,
    showBuktiKaryaSection,
    showCeritaPraktikSection,
    showPerangkatAjarSection,

    isProfileKaryaEmpty,
  }
}
